import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=4c9d6c7a&scoped=true"
import script from "./ShoppingList.vue?vue&type=script&lang=ts"
export * from "./ShoppingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d6c7a",
  null
  
)

export default component.exports